// extracted by css-extract-rspack-plugin
export default {"root":"MetricEditorHeader-module__root___nOcm0"};